export const currentYear = new Date().getFullYear();
export const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => {
    return {
      label: (start + i * step).toString(),
      value: (start + i * step).toString(),
    };
  });
